var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.5C0 1.39543 0.895431 0.5 2 0.5H12C13.1046 0.5 14 1.39543 14 2.5V3.5H0V2.5Z",
    fill: "#A1B1CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4H14V12.5C14 13.6046 13.1046 14.5 12 14.5H2C0.89543 14.5 0 13.6046 0 12.5V4Z",
    fill: "#A1B1CA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 5.5,
    width: 1.75,
    height: 1.75,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 5.5,
    width: 1.75,
    height: 1.75,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 5.5,
    width: 1.75,
    height: 1.75,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 8.5,
    width: 1.75,
    height: 1.75,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 8.5,
    width: 1.75,
    height: 1.75,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 8.5,
    width: 1.75,
    height: 1.75,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 11.5,
    width: 1.75,
    height: 1.75,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 11.5,
    width: 1.75,
    height: 1.75,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar_icon.0c35cf0a85b1a065baccb6b053aba8c3.svg";
export { ForwardRef as ReactComponent };